import React, { Component } from 'react';

// Constants
import config from 'common/oldJavascripts/config.js';

// Base Components
import Loader from 'common/components/Loader';

import QueryRefresher from 'common/components/QueryRefresher';
import Box from 'common/oldJavascripts/components/Base/Box';
import Table, { Cell, Row } from 'common/oldJavascripts/components/Base/Table';
import Header from 'common/oldJavascripts/components/Base/Header';
import Pagination from 'common/oldJavascripts/components/Base/Pagination';
import Blankslate from 'common/oldJavascripts/components/Base/Blankslate';
import Button from 'common/oldJavascripts/components/Base/Button';
import Link from 'common/oldJavascripts/components/Base/Link';

// Utilities
import history from 'common/constants/config/history';
import qs from 'qs';
import format from 'common/oldJavascripts/utils/format.js';
import T from 'common/oldJavascripts/utils/i18n';

// HoC
import withApi from 'common/hoc/withApi';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';

import BoxItem from 'common/oldJavascripts/components/Base/Box/BoxItem';

const styles = theme => ({
  loader: {
    backgroundColor: 'white',
    width: '100%',
    height: '200px',
  },
});

class ManualArchivesTable extends Component {
  static queries = {
    archives: {
      info: function(_, related) {
        var params = related['/router/params'];
        var query = related['/router/query'];

        return {
          id: '/projects/' + params.projectId + '/archives',
          cursor: {
            page: query.ma_page,
            per_page: query.per_page || config.DEFAULT_PER_PAGE,
          },
        };
      },
    },
  };

  changePage = page => {
    const { routerPath: pathname, routerQuery = {} } = this.props;
    history.push({
      pathname,
      search: qs.stringify({
        ...routerQuery,
        ma_page: page,
      }),
    });
  };

  renderRow = (archive = {}) => (
    <Row key={archive.id}>
      <Cell rowHeader={true}>
        <span data-test-id={`Archives-name-${archive.id}`}>
          {archive.first_name} {archive.last_name}
        </span>
      </Cell>
      <Cell>
        <span data-test-id={`Archives-position-${archive.id}`}>
          {archive.position}
        </span>
      </Cell>
      <Cell>
        <span data-test-id={`Archives-sentDate-${archive.id}`}>
          {format.date(archive.sent_date)}
        </span>
      </Cell>
      <Cell>
        <span data-test-id={`Archives-approvedDate-${archive.id}`}>
          {format.date(archive.approved_date)}
        </span>
      </Cell>
      <Cell>
        <Link
          to={`archives/${archive.id}`}
          data-test-id={`Archives-viewLink-${archive.id}`}
        >
          {T('archives.actions.view_packets')}
        </Link>
      </Cell>
    </Row>
  );

  renderContent = () => {
    const { archives: archivesQuery = {}, classes = {} } = this.props;
    const { status: archivesStatus, data: archives = {} } = archivesQuery;
    const { items: archivesItems = [] } = archives || {};

    const loading = archivesStatus === 'loading';
    const displayBlankSlate = !loading && archivesItems.length === 0;

    if (loading) return <Loader className={classes.loader} />;
    if (displayBlankSlate)
      return <Blankslate>{T('archives.not_found')}</Blankslate>;
    return (
      <Table>
        <Table.Header>
          <Cell header={true}>{T('archives.columns.name')}</Cell>
          <Cell header={true}>{T('archives.columns.position')}</Cell>
          <Cell header={true}>{T('archives.columns.sent_date')}</Cell>
          <Cell header={true}>{T('archives.columns.approved_date')}</Cell>
          <Cell header={true}>{T('archives.columns.actions')}</Cell>
        </Table.Header>
        {archivesItems.map(this.renderRow)}
      </Table>
    );
  };

  renderPagination = () => {
    const { archives: archivesQuery = {} } = this.props;
    const { status: archivesStatus, data: archives = {} } = archivesQuery;
    const { items: archivesItems = [], total_pages: totalPages, page } =
      archives || {};

    const loading = archivesStatus === 'loading';
    const displayContent = !loading && archivesItems.length > 0;

    if (displayContent)
      return (
        <Pagination
          totalPages={totalPages}
          page={page}
          onChange={this.changePage}
        />
      );
    return null;
  };

  render() {
    const { archives: { reload: reloadQuery } = {} } = this.props;

    return (
      <React.Fragment>
        <Box>
          <BoxItem>
            <Header>
              <Header.Title>{T('archives.manual.title')}</Header.Title>
              <QueryRefresher reloadQuery={reloadQuery} />
              <Header.Nav>
                <Button to={`archives/new`} data-test-id="Archives-addManual">
                  {T('archives.new.action')}
                </Button>
              </Header.Nav>
            </Header>
          </BoxItem>
          {this.renderContent()}
        </Box>
        {this.renderPagination()}
      </React.Fragment>
    );
  }
}

export default compose(
  withStyles(styles),
  withApi,
)(ManualArchivesTable);
